import * as React from 'react';

import { VALID_ICONS } from '../Icon/SVGIcon';
import { VALID_SVG_COLOR } from '../../lib/StyledComponents';

import { ISVGContainerProps, SvgContainer } from './Common/SVGContainer';

export interface IHeaderIconProps extends ISVGContainerProps {
  open: boolean;
  iconOpen?: VALID_ICONS;
  iconClosed?: VALID_ICONS;
  iconColor?: VALID_SVG_COLOR;
}

export const HeaderIcon: React.FunctionComponent<IHeaderIconProps> = ({
  open,
  iconOpen = 'arrow-top' as VALID_ICONS,
  iconClosed = 'arrow-bottom' as VALID_ICONS,
  iconHeight,
  iconWidth,
  iconColor
}) => (
  <SvgContainer
    iconHeight={iconHeight}
    iconWidth={iconWidth}
    icon={open ? iconOpen : iconClosed}
    iconStyle={iconColor}
  />
);

HeaderIcon.displayName = 'HeaderIcon';
HeaderIcon.defaultProps = {
  open: false,
};
